import React from "react";
import Slider from "react-slick";
import { FaQuoteLeft } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Testimonial.css";

const Testimonial = () => {
  const testimonials = [
    {
      name: "Rohit Sharma",
      role: "Frequent Traveler",
      message:
        "Amazing service! Booking my hotel was so smooth and quick. Definitely recommended.",
      image: "/Images/logo/man.png",
    },
    {
      name: "Anita Verma",
      role: "Business Traveler",
      message:
        "Customer support is very responsive. Got the best deals for my corporate trip.",
      image: "/Images/logo/woman.png",
    },
    {
      name: "Arjun Mehta",
      role: "Family Trip",
      message:
        "Loved the hassle-free experience. My family trip was perfectly organized.",
      image: "/Images/logo/man.png",
    },
    {
      name: "Sneha Kapoor",
      role: "Solo Traveler",
      message:
        "The booking experience was effortless. I’ll definitely book again!",
      image: "/Images/logo/woman.png",
    },
    {
      name: "Vikram Singh",
      role: "Honeymoon Trip",
      message:
        "Amazing hotel recommendations. Our honeymoon was unforgettable.",
      image: "/Images/logo/man.png",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 3,   // 👈 ek sath 3 cards
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2, // tablet view
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1, // mobile view
        },
      },
    ],
  };

  return (
    <section className="testimonials">
      <h2 className="testimonials-title">What Our Customers Say</h2>
      <Slider {...settings}>
        {testimonials.map((t, index) => (
          <div className="testimonial-card" key={index}>
            <FaQuoteLeft className="quote-icon" />
            <p className="testimonial-message">"{t.message}"</p>
            <div className="testimonial-user">
              <img src={t.image} alt={t.name} />
              <div>
                <h4>{t.name}</h4>
                <span>{t.role}</span>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default Testimonial;
